import React from 'react';
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Breadcrumb from './components/Breadcrumb';
import HomePage from './pages/Home';
import IhtiyacKredisi from './pages/IhtiyacKredisi';
import KrediKartlari from './pages/KrediKartlari';
import UzaktanMusteriEdinimi from './pages/UzaktanMusteriEdinimi';
import Mevduat from './pages/Mevduat';
import Hakkimizda from './pages/Hakkimizda';
import GizlilikPolitikasi from './pages/GizlilikPolitikasi';
import KVKKAydinlatmaMetni from './pages/KVKKAydinlatmaMetni';
import CerezPolitikasi from './pages/CerezPolitikasi';
import KullaniciSozlesmesi from './pages/KullaniciSozlesmesi';
import UyeGirisi from './pages/UyeGirisi';
import UyeOl from './pages/UyeOl';
import BankPage from './pages/BankPage';
import BankCredits from './pages/bank/BankCredits';
import BankCards from './pages/bank/BankCards';
import BankDeposits from './pages/bank/BankDeposits';
import BankNewCustomer from './pages/bank/BankNewCustomer';
import BankLoanPage from './pages/bank/BankLoanPage';
import Bildirimler from './pages/Bildirimler';
import DynamicPage from './pages/DynamicPage';
import BankDetailPage from './pages/BankDetailPage';

// Admin Pages
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import Applications from './pages/admin/Applications';
import Users from './pages/admin/Users';
import Reports from './pages/admin/Reports';
import LeadFlow from './pages/admin/LeadFlow';
import Settings from './pages/admin/Settings';
import BankManagement from './pages/admin/content/BankManagement';
import ProductManagement from './pages/admin/content/ProductManagement';
import CampaignManagement from './pages/admin/content/CampaignManagement';
import PageManagement from './pages/admin/content/PageManagement';
import AdvertisementManagement from './pages/admin/content/AdvertisementManagement';
import OrderManagement from './pages/admin/content/OrderManagement';
import BankOffersManagement from './pages/admin/content/BankOffersManagement';
import BankDetailManagement from './pages/admin/content/BankDetailManagement';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
const MainLayout = ({ children }: { children: React.ReactNode }) => (
  <div className="min-h-screen bg-slate-100">
    <Navbar />
    <Breadcrumb />
    {children}
    <Footer />
  </div>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Auth Routes - Full Page */}
        <Route path="/uye-girisi" element={<UyeGirisi />} />
        <Route path="/uye-ol" element={<UyeOl />} />

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="applications" element={<Applications />} />
          <Route path="users" element={<Users />} />
          <Route path="reports" element={<Reports />} />
          <Route path="reports/lead-flow" element={<LeadFlow />} />
          <Route path="settings" element={<Settings />} />
          <Route path="content/banks" element={<BankManagement />} />
          <Route path="content/bank-offers" element={<BankOffersManagement />} />
          <Route path="content/products" element={<ProductManagement />} />
          <Route path="content/campaigns" element={<CampaignManagement />} />
          <Route path="content/bank-details" element={<BankDetailManagement />} />
          <Route path="content/pages" element={<PageManagement />} />
          <Route path="content/advertisements" element={<AdvertisementManagement />} />
          <Route path="content/order" element={<OrderManagement />} />
        </Route>

        {/* Main Routes - With Layout */}
        <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
        <Route path="/ihtiyac-kredisi" element={<MainLayout><IhtiyacKredisi /></MainLayout>} />
        <Route path="/konut-kredisi" element={<MainLayout><IhtiyacKredisi /></MainLayout>} />
        <Route path="/tasit-kredisi" element={<MainLayout><IhtiyacKredisi /></MainLayout>} />
        <Route path="/kobi-kredisi" element={<MainLayout><IhtiyacKredisi /></MainLayout>} />
        <Route path="/kredi-kartlari" element={<MainLayout><KrediKartlari /></MainLayout>} />
        <Route path="/uzaktan-musteri-edinimi" element={<MainLayout><UzaktanMusteriEdinimi /></MainLayout>} />
        <Route path="/mevduat" element={<MainLayout><Mevduat /></MainLayout>} />
        <Route path="/hakkimizda" element={<MainLayout><Hakkimizda /></MainLayout>} />
        <Route path="/gizlilik-politikasi" element={<MainLayout><GizlilikPolitikasi /></MainLayout>} />
        <Route path="/kvkk-aydinlatma-metni" element={<MainLayout><KVKKAydinlatmaMetni /></MainLayout>} />
        <Route path="/cerez-politikasi" element={<MainLayout><CerezPolitikasi /></MainLayout>} />
        <Route path="/kullanici-sozlesmesi" element={<MainLayout><KullaniciSozlesmesi /></MainLayout>} />
        <Route path="/bildirimler" element={<MainLayout><Bildirimler /></MainLayout>} />
        
        {/* Bank Routes */}
        <Route path="/bankalar/:bankId" element={<MainLayout><BankPage /></MainLayout>} />
        <Route path="/bankalar/:bankId/krediler" element={<MainLayout><BankCredits /></MainLayout>} />
        <Route path="/bankalar/:bankId/kredi-kartlari" element={<MainLayout><BankCards /></MainLayout>} />
        <Route path="/bankalar/:bankId/mevduat" element={<MainLayout><BankDeposits /></MainLayout>} />
        <Route path="/bankalar/:bankId/yeni-musteri" element={<MainLayout><BankNewCustomer /></MainLayout>} />

        {/* Bank Detail Route */}
        <Route path="/banka/:bankId" element={<MainLayout><BankDetailPage /></MainLayout>} />

        {/* Bank-specific product routes */}
        <Route path="/:loanType/:bankId" element={<MainLayout><BankLoanPage /></MainLayout>} />
        
        {/* Dynamic Page Route - Must be last to avoid overriding other routes */}
        <Route path="/:slug" element={<MainLayout><DynamicPage /></MainLayout>} />
      </Routes>
    </Router>
  );
}

export default App;